module.exports = __webpack_public_path__ + "img/vue-leaflet.7952c08e.png";